import useReactQuery from '../common/useReactQuery';

const useRegisterInvitation = () => {
  const { useMutation } = useReactQuery();

  return useMutation<void>({
    method: 'POST',
    url: '/api/school/parents/invitations/registers',
  });
};

export default useRegisterInvitation;
